/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query ResourcesQuery($uid: String!) {
    prismic {
      resources(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_ResourcesBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        },
        ... on PRISMIC_ResourcesBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_ResourcesBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_ResourcesBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Resources = ({ data, location }) =>
  data.prismic.resources ? (
    <MainLayout location={location} layout='resources'>
    <Helmet>
      <title>{(data.prismic.resources.title[0] && data.prismic.resources.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.resources.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.resources.path : 'https://www.digitalocean.com' + data.prismic.resources.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.resources.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.resources.title[0] ? data.prismic.resources.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.resources.description ? data.prismic.resources.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.resources.open_graph_image ? data.prismic.resources.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.resources.description ? data.prismic.resources.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.resources.title[0] ? data.prismic.resources.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.resources.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.resources.path : 'https://www.digitalocean.com' + data.prismic.resources.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.resources.open_graph_image ? data.prismic.resources.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.resources.body} />
    </MainLayout>
  ) : null;

Resources.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Resources;
